// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global overrides loaded after all other styles */

/* Force table wrappers to allow vertical overflow for dropdown escape */
.table-responsive,
[class*="tableWrapper"],
[class*="tableContainer"] {
  overflow-y: visible !important;
}

/* Keep horizontal clipping for border-radius */
.table-responsive,
[class*="tableWrapper"] {
  overflow-x: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/global-overrides.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD,wEAAwE;AACxE;;;EAGE,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;;EAEE,2BAA2B;AAC7B","sourcesContent":["/* Global overrides loaded after all other styles */\n\n/* Force table wrappers to allow vertical overflow for dropdown escape */\n.table-responsive,\n[class*=\"tableWrapper\"],\n[class*=\"tableContainer\"] {\n  overflow-y: visible !important;\n}\n\n/* Keep horizontal clipping for border-radius */\n.table-responsive,\n[class*=\"tableWrapper\"] {\n  overflow-x: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
